var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 20.1667 17.4167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M13.5971 0.0326004C12.275 0.167626 11.0384 0.731448 10.0838 1.63211C9.21314 0.816041 8.10917 0.274451 6.91522 0.0800816C5.7228 -0.11281 4.49684 0.0489224 3.40048 0.546005C2.38953 1.01637 1.53562 1.75233 0.934824 2.67081C0.332501 3.59077 0.00924565 4.65613 0.00011128 5.74523C-0.0303854 11.2443 6.21539 15.5131 8.90378 17.0948H8.90226C9.25907 17.3055 9.66771 17.4167 10.0855 17.4167C10.4987 17.4167 10.9028 17.3055 11.2566 17.0962C13.8595 15.5665 19.9389 11.4296 20.1587 6.08061C20.2487 4.39058 19.5732 2.74804 18.3106 1.58471C17.048 0.421381 15.3261 -0.146955 13.5971 0.0326004ZM10.2531 15.4727V15.4712C10.1494 15.5336 10.0183 15.5336 9.91306 15.4712C8.03903 14.3688 1.92751 10.4071 1.95327 5.75697V5.75845C1.96242 4.04765 3.11978 2.5431 4.80472 2.05492C6.48966 1.56826 8.3042 2.21072 9.27236 3.63961C9.4523 3.90521 9.75727 4.06398 10.0851 4.06398C10.4114 4.06398 10.7179 3.90522 10.8978 3.63961C11.5596 2.66921 12.6331 2.03862 13.824 1.9214C15.0149 1.8027 16.1966 2.21074 17.046 3.03129C17.845 3.81917 18.2704 4.89642 18.217 6.00182C18.0203 10.557 12.072 14.4075 10.2514 15.4715L10.2531 15.4727Z",
    fill: "var(--fill-0, #29363D)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutline);
export default __webpack_public_path__ + "static/media/heart-outline.3507d36d940ad61cdd3c252b89dbc32b.svg";
export { ForwardRef as ReactComponent };